import url_ from "asset-data:assets/galleries/test/L1000394-color_85eacc6a9a__800.jpg";
export const url = url_;